<div class="col-md-6 offset-md-3 mt-5">
  <!-- <div class="alert alert-info">
  Username: test<br />
  Password: test
</div> -->
<div class="ng-container login-logo">
  <img src="assets/login-logo.png">
</div>
<div class="card">
  <h4 class="card-header">Entrarit - Web Login</h4>
  <div class="card-body">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="username">Username</label>
        <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted() && f.username.errors }" />
        @if (submitted() && f.username.errors) {
          <div class="invalid-feedback">
            @if (f.username.errors.required) {
              <div>Username is required</div>
            }
          </div>
        }
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <div class="input-group">
          <input [type]="showPassword() ? 'text' : 'password'" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted() && f.password.errors }" />
          <button type="button" class="btn btn-outline-secondary" (click)="togglePasswordVisibility()" [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'">
            <fa-icon [icon]="showPassword() ? faEyeSlash : faEye"></fa-icon>
          </button>
        </div>
        @if (submitted() && f.password.errors) {
          <div class="invalid-feedback">
            @if (f.password.errors.required) {
              <div>Password is required</div>
            }
          </div>
        }
      </div>

      <button type="button" (click)="openRegistration()" class="btn btn-primary">
        Register <fa-icon [icon]="faUserPlus"></fa-icon>
      </button>

      <button id="loginbtn" [disabled]="loading()" class="m-2 btn btn-success float-right">
        @if (loading()) {
          <span class="spinner-border spinner-border-sm mr-1"></span>
        }
        Login  <fa-icon class="l-icon" [icon]="faSignInAlt"></fa-icon>
      </button>
      <div>
        <button (click)="openForgetPassword()" type="button" class="mt-1 btn btn-link">Forgot password/username?</button>
      </div>
      <div>
        <button routerLink="/guest-access" type="button" class="mt-2 btn btn-outline-primary">
          Guest Access <fa-icon [icon]="faKey"></fa-icon>
        </button>
      </div>
      @if (pastLogin()) {
        <div class="mt-4">
          <button  type="button" class="btn btn-warning" (click)="openQuickAccess()">Quick Access <fa-icon class="l-icon" [icon]="faTachometerAlt"></fa-icon></button>
        </div>
      }
      @if (error()) {
        <div class="alert alert-danger mt-3 mb-0">{{error()}}</div>
      }
    </form>
  </div>
</div>
</div>
